import React from 'react';
import PropTypes from 'prop-types';

import AlphaSlider from './AlphaSlider';
import CutoffsFields from './CutoffsFields';

const CIFieldsComponent = props =>
  <div>
    <AlphaSlider {...props} />
    <CutoffsFields {...props} />
  </div>;

CIFieldsComponent.propTypes = {
  mean: PropTypes.number.isRequired,
  stdev: PropTypes.number.isRequired,

  form: PropTypes.string.isRequired
};

export default CIFieldsComponent;
